import { Card, Alert, Empty, Row, Col, Button, message } from 'antd';
import React from 'react';
import { use, api, app } from 'xadmin';
import { Page, C, Icon } from 'xadmin-ui'
import NoData from '../../components/NoData';
import { ReloadOutlined } from '@ant-design/icons'

const SystemOperation = props => {
  const ops = app.get('systemOperation').reduce((ops, op) => {
    const grp = op.group || '系统操作'
    if (ops[grp] == undefined) {
      ops[grp] = []
    }
    ops[grp].push(op)
    return ops
  }, {})

  const loadService = (name, title) => {
    api({ name })
      .fetch('', {})
      .then(({ json }) => {
        message.success(title + '成功')
      })
      .catch(err => {
        message.error(err.message,err?.detail)
      })
  }

  const ColReloadBtn = ({ name, title }) => (
    <Col sm={6} style={{ marginBottom: '.5rem' }}>
      <Button size="large" style={{ width: "100%" }} onClick={() => loadService(name, title)}>
        <ReloadOutlined />{title || ''}
      </Button>
    </Col>
  )

  let order = ["驱动操作", "系统仿真", "事件handle", "计量操作"]
  return (
    <Page title={<span><Icon svg={require('../../icon/系统设置.svg')} />系统操作</span>}>
      <Alert message="注意，请谨慎使用系统操作功能！！！" type="warning" showIcon style={{ marginBottom: '1rem' }} />
      {ops && Object.keys(ops).length > 0 ? (
        Object.keys(ops).sort((a, b) => order.indexOf(a) - order.indexOf(b)).map(grp => {
          const opList = ops[grp]
          return (
            <Card title={grp} style={{ marginBottom: '1rem' }}>
              {opList && grp == '驱动操作' ? opList[0].renderComponent :
                <Row gutter={8}>
                  {opList.map(op => <Col sm={6} style={{ marginBottom: '.5rem' }}>{op.component}</Col>)}
                </Row>
              }
              {
                grp == "事件handle" ? <Row gutter={8}>
                  <ColReloadBtn name="email/handler/reload" title="重启邮件服务" />
                  <ColReloadBtn name="scriptNode/handler/reload" title="重启事件脚本服务" />
                </Row> : null
              }
            </Card>
          )
        })
      ) : <Card style={{ marginBottom: '1rem' }}><NoData description="暂无可用的系统操作" /></Card>
      }
      {/* {
        <Card title="事件handle">
          <Button size="small" onClick={() => { loadService() }}>邮件服务重新加载</Button>
        </Card>
      } */}
    </Page>
  )
}

export default SystemOperation
